import { hasPermission } from '../../helpers/helpers';
import { useUserProfile } from '../../context/UserProfileContext/UserProfileContext';
import { PropsWithChildren, useMemo } from 'react';
import { AppBaseHref } from '@partnerconnect-monorepo/types/EnvironmentVariables';
import { NoAccess } from '../../pages/NoAccess/NoAccess';
import { FullLayout } from '../../Layout/FullLayout';

export const PrivateRoute = ({
  children,
  permissionCheck
}: PropsWithChildren<{ permissionCheck: string | null }>) => {
  const { userProfile } = useUserProfile();

  const canAccessReporting = useMemo(
    () =>
      window.location.pathname.includes(AppBaseHref.Reporting) &&
      userProfile?.allowedModules?.canAccessReporting,
    [userProfile?.allowedModules?.canAccessReporting]
  );

  const canAccessPartnerships = useMemo(
    () =>
      window.location.pathname.includes(AppBaseHref.Partnerships) &&
      userProfile?.allowedModules?.canAccessPartnerships,
    [userProfile?.allowedModules?.canAccessPartnerships]
  );

  const canAccessInvoicing = window.location.pathname.includes(
    AppBaseHref.Invoicing
  );

  const canAccessSpotchecks = window.location.pathname.includes(
    AppBaseHref.Spotcheck
  );

  const isAccessingUnprotectedPathname = useMemo(
    () =>
      [
        AppBaseHref.Reporting,
        AppBaseHref.Partnerships,
        AppBaseHref.Invoicing,
        AppBaseHref.Spotcheck
      ].every((pathname) => !window.location.pathname.includes(pathname)),
    []
  );

  const canAccessProtectedModule =
    canAccessReporting ||
    canAccessPartnerships ||
    canAccessInvoicing ||
    canAccessSpotchecks;

  const canAccess = useMemo(
    () =>
      userProfile &&
      (canAccessProtectedModule || isAccessingUnprotectedPathname) &&
      permissionCheck
        ? hasPermission(userProfile?.permissions, permissionCheck)
        : false,
    [
      canAccessProtectedModule,
      isAccessingUnprotectedPathname,
      permissionCheck,
      userProfile
    ]
  );

  return canAccess ? (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{children}</>
  ) : (
    <FullLayout>
      <NoAccess />
    </FullLayout>
  );
};
